module.exports = __webpack_public_path__ + "img/Dantam Bridal 17.e55f1cc4.jpg";